import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const StartupJourneySectionSv = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate('/sv/startup-journey');
  };

  return (
    <section className="py-16 bg-gradient-to-br from-slate-50 to-blue-50 animate-on-scroll relative">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-4xl">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Startup-resan
            </h2>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Olika typer av startups möter unika utmaningar och följer distinkta vägar till framgång. Oavsett om du bygger AI-lösningar, transformerar traditionella industrier eller utvecklar banbrytande deeptech, är förståelsen för dessa skillnader avgörande för din tillväxtresa.
            </p>

            <p
              className="text-lg text-gray-700 mb-8 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: 'Startup-resan går vanligtvis genom fem nyckelstadier: <strong>Idé</strong> (konceptualisering och validering), <strong>Starta upp</strong> (bygga grunden och tidig utveckling), <strong>Accelerera</strong> (skala verksamheten och marknadstillväxt), <strong>Global expansion</strong> (internationell marknadsinträde och tillväxt), och slutligen <strong>Exit eller mognad</strong> (strategiska exits eller att bli en etablerad marknadsaktör).' }}
            />

            <Button
              variant="cyan"
              size="lg"
              onClick={handleLearnMore}
              className="px-12 py-6 text-xl font-bold rounded-full"
            >
              Läs mer om Startup-resan
              <ArrowRight className="ml-3 h-6 w-6" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartupJourneySectionSv;
